import { render, staticRenderFns } from "./ManagementSurveyListSolutions.vue?vue&type=template&id=736870ac&"
import script from "./ManagementSurveyListSolutions.vue?vue&type=script&lang=js&"
export * from "./ManagementSurveyListSolutions.vue?vue&type=script&lang=js&"
import style0 from "./ManagementSurveyListSolutions.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports